module.exports = __webpack_public_path__ + "static/media/placeGray.f7f6ff04.svg";